var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.boards.length !== 0)?_c('v-row',_vm._l((_vm.boards),function(board){return _c('CardBoard',{key:board.id,attrs:{"board":board}})}),1):_c('div',{staticClass:"text-h5"},[_vm._v("No tienes tableros")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }